import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  user: null,
  alerts: [],
  isAppJsLoaded: false,
  clientUserInactiveTimeoutInMinutes: 60,
  isAppLoading: false,
  banners: []
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export const modules = []



// WEBPACK FOOTER //
// ./src/store/index.js